import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { RouterProvider } from "react-router-dom"

// Import scss
import "./assets/scss/theme.scss"
import "react-toastify/dist/ReactToastify.css"

import AppRouter from "routes/AppRouter"
import useAuth from "hooks/useAuth"
import { ToastContainer } from "react-toastify"

const App = () => {
  const { isLoading, getUserProfile } = useAuth()

  useEffect(() => {
    getUserProfile()
  }, [])

  if (isLoading) {
    return (
      <div className="screen-loading">
        <div className="loader"></div>
      </div>
    )
  }

  return (
    <React.Fragment>
      <ToastContainer position="top-right" stacked={true} draggable />
      <RouterProvider router={AppRouter} />
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
